import Helper from "./Helper";

class Matrix {
  constructor() {

    const matrix = document.querySelectorAll('.ns-matrix');
    let lastTarget = false;

    if(!!matrix){
      matrix.forEach(m => {


      const triggers = m.querySelectorAll('[id*="trigger-"]');
      triggers.forEach( trigger => {

        if(window.innerWidth > 1024){
          trigger.addEventListener('mouseenter', () => {
            console.log(trigger.id.replace('trigger', 'target'));
            const target = m.querySelector('#'+trigger.id.replace('trigger', 'target'));
            if(!!target){
              if(!!lastTarget){
                lastTarget.style.display = 'none';
              }
              target.style.display = 'block';
              lastTarget = target;
              target.addEventListener('mouseleave', () => {
                target.style.display = 'none';
                lastTarget = false;
              })
            }
          });

        } else {


          trigger.addEventListener('click', () => {
            const target = m.querySelector('#'+trigger.id.replace('trigger', 'target'));
            if(!!target){
              if(!!lastTarget){
                lastTarget.style.display = 'none';
              }
              target.style.display = 'block';
              lastTarget = target;
              target.addEventListener('click', () => {
                target.style.display = 'none';
                lastTarget = false;
              })
            }
          });
        }

      });
    });
    }

  }
}

export default Matrix;
